<template>
  <div>
    <div class="form-group"
         v-touch:swipe.stop="noSwipe">
      <vue-slider ref="slider"
                  v-model="question.GivenAnswer"
                  v-bind="options">
        <template slot="piecewise" slot-scope="{ label, active }">
            <span :class="['piecewise-style', { active }]" v-if="label % 10 === 0">
              |
            </span>
        </template>
        <template slot="label" slot-scope="{ label, active }">
          <span :class="['label-style', { active }]" v-if="label % 20 === 0">
            {{ label }}
          </span>
        </template>
      </vue-slider>
    </div>
  </div>
</template>

<script>
  import vueSlider from 'vue-slider-component'

  export default {
    props: {
      question: {
        required: true,
        type: Object,
      },
    },
    components: {vueSlider},
    created () {
      if (!this.question.GivenAnswer) {
        this.question.GivenAnswer = 0
      }
      let vm = this
      setTimeout(function () {
        vm.$nextTick(() => vm.$refs.slider.refresh())
      }, 500)
    },
    methods: {
      noSwipe () {
        console.info('Slider swipe prevented')
      }
    },
    data () {
      return {
        options: {
          show: true,
          min: 0,
          max: 100,
          interval: 1,
          tooltipDir: 'top',
          width: 'auto',
          piecewise: true,
          piecewiseLabel: true,
          style: {
            marginTop: '50px',
            marginBottom: '50px'
          },
          tooltipStyle: {
            backgroundColor: '#3A86FF',
            borderColor: '#3A86FF',
            width: '50px',
            height: '40px'
          },
          processStyle: {
            backgroundColor: '#3A86FF',
            borderColor: '#3A86FF',
          },
          bgStyle: {
            backgroundColor: '#fff',
            boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
          }
        },
      }
    },
  }
</script>

<style scoped>
  .label-style {
    font-size: 15px;
    position: absolute;
    transform: translate(-50%, -10px);
  }

  .piecewise-style {
    font-size: 10px;
  }

  .active {
    color: #3A86FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Percentage.vue